const DELIVERY_METHOD_LABELS: Record<string, string> = {
  sms_payment_link: 'SMS payment link',
  card_on_file: 'card on file',
  stripe_invoice: 'Stripe invoice',
  new_card: 'new card',
  sms: 'SMS',
};

export function formatDeliveryMethod(method: string | null | undefined, fallback = '—'): string {
  if (!method) return fallback;
  return DELIVERY_METHOD_LABELS[method] ?? method.replace(/_/g, ' ');
}
